<h1 mat-dialog-title class="dialog-feedback-title">Teacher Feedback</h1>
<div mat-dialog-content class="dialog-feedback-content">
    <p class="dialog-feedback-text" [innerHTML]="data.feedback"></p>
    <p class="dialog-feedback-date">
        <span class="label">Sent: </span>{{data.feedbackUpdatedAt}}
    </p>
</div>
<div mat-dialog-actions fxLayoutAlign="center center">
    <button mat-button (click)="close()" cdkFocusInitial>Ok</button>
</div>
